import type { MessageKey } from './catalogs';

/**
 * THE SYSTEM ROLES, NAMED FOR A PERSON in their language. A custom role has no
 * catalog entry and is shown by the name its organization gave it — or, where
 * only the key is known, by the key, which is still a name somebody chose.
 *
 * Every key in `SYSTEM_ROLES` (`packages/db/src/rbac.ts`) belongs here. The
 * module roles of #843 were not, so «Dine rettigheter» read `TENANT_RECEPTION`
 * (#861); `account-rights.test.tsx` walks `SYSTEM_ROLES`, so the next system
 * role fails a test instead of reaching a screen as a key.
 *
 * ONE MAP, TWO SCREENS. «Min konto» names the roles a person holds and the
 * organization's «Tilganger» page (slice 3) names the roles it hands out, and
 * its «Samarbeid» page (slice 4a) the LINK roles each side gives; a copy in
 * each is how the same role ends up with two names.
 */
export const ROLE_NAME: Partial<Record<string, MessageKey>> = {
  PLATFORM_SUPERADMIN: 'role.PLATFORM_SUPERADMIN',
  PLATFORM_SUPPORT: 'role.PLATFORM_SUPPORT',
  PLATFORM_FINANCE: 'role.PLATFORM_FINANCE',
  PLATFORM_OPERATIONS: 'role.PLATFORM_OPERATIONS',
  PLATFORM_READONLY: 'role.PLATFORM_READONLY',
  TENANT_OWNER: 'role.TENANT_OWNER',
  TENANT_ADMIN: 'role.TENANT_ADMIN',
  TENANT_MANAGER: 'role.TENANT_MANAGER',
  TENANT_STAFF: 'role.TENANT_STAFF',
  TENANT_READONLY: 'role.TENANT_READONLY',
  TENANT_RECEPTION: 'role.TENANT_RECEPTION',
  TENANT_VENUE: 'role.TENANT_VENUE',
  TENANT_TOURNAMENTS: 'role.TENANT_TOURNAMENTS',
  TENANT_ACTIVITIES: 'role.TENANT_ACTIVITIES',
  TENANT_MEMBERSHIP: 'role.TENANT_MEMBERSHIP',
  TENANT_COMMUNICATION: 'role.TENANT_COMMUNICATION',
  TENANT_FINANCE: 'role.TENANT_FINANCE',
  // Slice 4a: the system LINK roles, named on the organization's «Samarbeid» page.
  LINK_PARTNER_CLUB: 'role.LINK_PARTNER_CLUB',
  LINK_HOST_CENTRE: 'role.LINK_HOST_CENTRE',
};

/** The catalog key naming a system role, or null for a role the catalog does not know. */
export function roleNameKey(key: string): MessageKey | null {
  return ROLE_NAME[key] ?? null;
}
